import React, {useState} from 'react';
import { NavLink } from 'react-router-dom';

import { CheckIcon } from '@heroicons/react/outline';

//functions
import { deleteContact } from '../functions/DeleteContact';
import { deleteAllImportedCon } from '../functions/DeleteAllImportedCon';

//components
import ContactsForProsp from '../contactsForProsp/ContactsForProsp';
import LoadingSpinner from '../../../loadingSpinner/LoadingSpiner';


function ShowContactsV2({ contacts, profile, auth, checkedContacts }) {

  const[ showSpinn, setShowSpinn ] = useState(false)

  return (
    <div className="flex flex-col">
      {!showSpinn ?
      <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
            <div className='flex'>
              {checkedContacts?.length > 0 ?
              <div className="mt-2 mb-2">
                <NavLink
                exact
                to='/prospects'
                style ={{textDecoration:'none'}}
                onClick={()=>deleteAllImportedCon(profile)}
                >
                  <button
                  type="button"
                  className="inline-flex items-center bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded ml-4 focus:outline-none focus:ring focus:border-indigo-300 animate-pulse disabled:opacity-50"
                  >
                    <CheckIcon className="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />
                    View Imported
                  </button>
                </NavLink> 
              </div>
              : null }
              {contacts?.length > 0 ?
                <div className="ml-auto mr-2">
                <ContactsForProsp contacts={contacts} fbProfile={profile} auth={auth} setShowSpinn={setShowSpinn}/>
                </div>
                :
                null
              }
            </div>
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr> 
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                     LinkedIn URL
                  </th>
                  <th scope="col" className="relative px-6 py-3">
                    <span className="sr-only">Delete</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {contacts?.length > 0 ? contacts.map((contact, index) => (
                  <tr key={index} value={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                    <td className="px-6 py-4 whitespace-pre-line text-sm font-medium text-gray-900">{contact.contactLinkedin}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <button 
                        className="text-indigo-600 hover:text-indigo-900"
                        onClick={()=> deleteContact(contact.id, profile)}
                    >
                        Delete
                      </button>
                    </td>
                  </tr>
                )) : null}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      :
      <LoadingSpinner />
      }
    </div>
    )
}

export default ShowContactsV2